'use client';
import { rem } from '../../../../utils/units-converters/rem.mjs';
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
import { colorsTuple } from '../../../../MantineProvider/color-functions/colors-tuple/colors-tuple.mjs';
import '../../../../MantineProvider/Mantine.context.mjs';
import '../../../../MantineProvider/default-theme.mjs';
import '../../../../MantineProvider/MantineProvider.mjs';
import '../../../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { colorResolver } from '../color-resolver/color-resolver.mjs';

function borderResolver(value, theme) {
  if (typeof value === "number") {
    return rem(value);
  }
  if (typeof value === "string") {
    const [size, style, ...colorTuple] = value.split(" ").filter((val) => val.trim() !== "");
    let result = `${rem(size)}`;
    style && (result += ` ${style}`);
    colorsTuple.length > 0 && (result += ` ${colorResolver(colorTuple.join(" "), theme)}`);
    return result.trim();
  }
  return value;
}

export { borderResolver };
//# sourceMappingURL=border-resolver.mjs.map
